import CommonHelmet from '@src/components/CommonHelmet';
import TwoFactorGuard from '@src/components/guard/TwoFactorGuard';
import TwoFactorForm from '@src/features/tenant/auth/TwoFactorForm';
import TenantCenterCardLayout from '@src/layouts/tenant/TenantCenterCardLayout';

function TenantTwoFactor() {
  return (
    <TwoFactorGuard isTenant={true}>
      <TenantCenterCardLayout>
        <CommonHelmet />
        <TwoFactorForm />
      </TenantCenterCardLayout>
    </TwoFactorGuard>
  );
}

export default TenantTwoFactor;
